module.exports = __webpack_public_path__ + "img/4.5d48f3d2.png";